<!--begin::Main-->
<ng-container>
  <!-- begin:: Header Mobile -->
  <app-header-mobile
    #ktHeaderMobile
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    [ngClass]="headerMobileClasses"
  >
</app-header-mobile>
  <!-- end:: Header Mobile -->

  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <ng-container *ngIf="asideSelfDisplay">
        <ng-container *ngIf="asideMenuStatic">
          <!--begin::STATIC Aside-->
          <app-aside
            #ktAside
            id="kt_aside"
            class="aside aside-left d-flex flex-column flex-row-auto"
            [ngClass]="asideCSSClasses"
          ></app-aside>
          <!--end::STATIC Aside-->
        </ng-container>
        <ng-container *ngIf="!asideMenuStatic">
          <!--begin::DYNAMIC Aside-->
          <app-aside-dynamic
            #ktAside
            id="kt_aside"
            class="aside aside-left d-flex flex-column flex-row-auto"
            [ngClass]="asideCSSClasses"
          ></app-aside-dynamic>
          <!--end::DYNAMIC Aside-->
        </ng-container>
      </ng-container>
      <!-- end:: Aside Left -->

      <!--begin::Wrapper-->
      <div  class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
        <!-- begin:: Header -->
        <app-header
          #ktHeader
          id="kt_header"
          class="header header-fixed"
        ></app-header>
        <!-- end:: Header -->

        <section class="main-menu" *ngIf="false">
          <div class="container">
            <div class="main-menu-wrap" *ngIf="false">
              <div class="main-menu">
                <a class="main-link" href="" routerLink="/home" target="" title=""><i class="fa  fa-home"></i></a>
                <a class="main-link" href="" *ngIf="permissionMenu.VerPolizas==1" routerLink="/list-insurance" target="" title=""><i class="fa fa-shield-alt"></i> <span class="menu-text pl-2" translate="MENU.INSURANCE"></span></a>
                <a class="main-link" href="" *ngIf="permissionMenu.VerCargarDocumentos==1" routerLink="/list-documents" target="" title=""><i class="fa fa-file"></i> <span class="menu-text pl-2" translate="MENU.DOCUMENTS"></span></a>
                <a class="main-link" href="" *ngIf="permissionMenu.VerSolicitudEndosos==1" routerLink="/list-request" target="" title=""><i class="fa fa-pen-alt"></i> <span class="menu-text pl-2" translate="MENU.REQUEST"></span></a>
                
				<div ngbDropdown class="d-inline-block" *ngIf="permissionMenu.VerCotizacion==1">
					<button class="btn main-link" id="dropdownQuotes" ngbDropdownToggle>
						<i class="fa fa-pen-alt"></i> <span class="menu-text pl-2" translate="MENU.QUOTES"></span>
					</button>
					<div ngbDropdownMenu aria-labelledby="dropdownQuotes" class="item-dropdownMenu">
					  <button class="dropdown-item font-weight-bold" *ngIf="permissionMenu.VerCotizacionVida==1" routerLink="/quotes-life" translate="QUOTES.QUOTESOFLIFE"></button>
                      <button class="dropdown-item font-weight-bold" *ngIf="permissionMenu.VerEvaluacionCotizacionVida==1" routerLink="/quotes-life-cz" translate="QUOTES.QUOTESCZ"></button>
					</div>
				</div>

                <div ngbDropdown class="d-inline-block" *ngIf="permissionMenu.VerReclamos==1">
					<button class="btn main-link" id="dropdownQuotes" ngbDropdownToggle>
						<i class="fa fa-pen-alt"></i> <span class="menu-text pl-2" translate="MENU.CLAIMS"></span>
					</button>
					<div ngbDropdownMenu aria-labelledby="dropdownQuotes" class="item-dropdownMenu">
					  <button class="dropdown-item font-weight-bold" *ngIf="permissionMenu.VerNotificarReclamos==1" routerLink="/create-claim" translate="CLAIMS.CREATE_CLAIMS"></button>
                      <button class="dropdown-item font-weight-bold" *ngIf="permissionMenu.VerConsultarReclamos==1" routerLink="/list-claims"  translate="CLAIMS.LIST_CLAIMS"></button>
					</div>
				</div>

                <a class="main-link" href="" *ngIf="permissionMenu.VerInformes==1" routerLink="/list-estatements" target="" title=""><i class="fa fa-file-alt"></i> <span class="menu-text pl-2" translate="MENU.ACCOUNT_ESTATEMENTS"></span></a>
                <a class="main-link" href="" *ngIf="permissionMenu.VerFormularios==1" routerLink="/list-documents-form" target="" title=""><i class="fa fa-edit"></i> <span class="menu-text pl-2" translate="MENU.DOCUMENT_FORMS"></span></a>
                <a class="main-link" href="" *ngIf="permissionMenu.VerPagoPoliza==1" routerLink="/payments"target="" title=""><i class="fa fa-credit-card"></i> <span class="menu-text pl-2" translate="MENU.PAYMENTS"></span></a>
              </div>
          </div>
        </div>
        </section>

        <!-- begin:: Content -->
        <div
          class="content d-flex flex-column flex-column-fluid pt-0"
          id="kt_content"
          [ngClass]="contentClasses"
        >

          <!-- begin:: Content Body -->
          <ng-container *ngIf="contentExtended">
            <router-outlet></router-outlet>
          </ng-container>

          <ng-container *ngIf="!contentExtended">
            <!--begin::Entry-->
            <div class="d-flex flex-column-fluid">
              <!--begin::Container-->
              <div class="container" >
                <router-outlet></router-outlet>
                <!--end::Container-->
              </div>
            </div>
            <!--end::Entry-->
          </ng-container>
          <!-- end:: Content Body -->
        </div>
        <ng-container *ngIf="footerDisplay">
          <app-footer
            class="footer bg-white py-4 d-flex flex-lg-column w-100"
            id="kt_footer"
            [ngClass]="footerCSSClasses"
          ></app-footer>
        </ng-container>
      </div>
      <!--end::Wrapper-->
    </div>
    <!-- end:: Body -->
    <!--end::Page-->

    <!--begin::Offcanvases-->
    <ng-container *ngIf="extrasSearchOffcanvasDisplay">
      <app-search-offcanvas></app-search-offcanvas>
    </ng-container>

    <ng-container *ngIf="extrasNotificationsOffcanvasDisplay">
      <app-notifications-offcanvas></app-notifications-offcanvas>
    </ng-container>

    <ng-container *ngIf="extrasQuickActionsOffcanvasDisplay">
      <app-quick-actions-offcanvas></app-quick-actions-offcanvas>
    </ng-container>

    <ng-container *ngIf="extrasCartOffcanvasDisplay">
      <app-cart-offcanvas></app-cart-offcanvas>
    </ng-container>

    <ng-container *ngIf="extrasQuickPanelDisplay">
      <app-quick-panel-offcanvas></app-quick-panel-offcanvas>
    </ng-container>

    <ng-container *ngIf="extrasUserOffcanvasDisplay">
      <app-user-offcanvas></app-user-offcanvas>
    </ng-container>

    <app-toolbar></app-toolbar>

    <ng-container *ngIf="extrasScrollTopDisplay">
      <app-scroll-top></app-scroll-top>
    </ng-container>
    <!--end::Offcanvases-->
  </div>
</ng-container>


<div class="alertUpdateProfileModal">
    <ng-template #alertUpdateProfileModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title">{{ "MYPROFILE.EDITPROFILE" | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <p>{{ "MYPROFILE.UPDATEALERT" | translate}}</p>
                </div>
            </div>
        </div>
        <div class="modal-footer" >
            <button type="button" class="btn btn-secondary  mr-2" (click)="c('')">{{ "INPUT.CLOSE" | translate }}</button>
            <button type="submit" class="btn btn-success" (click)="submitUpdateProfile()">{{ "INPUT.UPDATE" | translate }}</button>
        </div>
    </ng-template>
</div>